import { REHYDRATE } from "redux-persist/es/constants";
import { Middleware } from "redux";

export const UserMiddlewareConfig = {
	logout: () => {
		console.error( "Logout callback not configured" );
	},
};

export const UserVersionMiddleWare: Middleware = ( { getState } ) => next => ( action ) => {
	if ( action && action.type === REHYDRATE ) {
		if ( action.payload && action.payload.User && action.payload.User.user ) {
			const cv = action.payload.User.user.version;
			const rv = action.payload.User.RequiredUserVersion;
			if ( rv && rv !== cv ) {
				setTimeout( UserMiddlewareConfig.logout, 100 );
			}
		}
	}
	const result = next( action );
	return result;
};
